import styled from 'styled-components';

const Wrapper = styled.div`
  display: block;
  padding: 16px;
  width: 100%;
  background: ${(props) => props.theme.colors.outline};
  border-radius: 12px;
  overflow: hidden;
  font-family: ManropeLight, sans-serif;
  margin-bottom: 16px;

  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    font-size: 16px;
    margin-bottom: 16px;
    cursor: default;

      .header-title {
        margin-right: auto;
      }

      .auto-generated-badge {
        font-family: ManropeBold, sans-serif;
        font-size: 11px;
        text-transform: uppercase;
        color: ${(props) => props.theme.colors.inactive};
        background: ${(props) => props.theme.colors.inactive}22;
        border-radius: 6px;
        padding: 4px 8px;
        margin-left: 12px;
        white-space: nowrap;
      }

      .dropdown-icon {
        height: 20px;
        width: 20px;
        cursor: pointer;
        text-align: center;
      }

      .widget-menu {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        width: 160px;
        background: ${(props) => props.theme.colors.widget_background};
        box-shadow: ${(props) => props.theme.shadows.dropdown};
        border-radius: 12px;
        
        li {
          display: flex;
          align-items: center;
          gap: 8px;
          width: 100%;
          padding: 17px 16px;
          font-family: ManropeBold, sans-serif;
          font-size: 13px;
          line-height: 18px;
          cursor: pointer;

          button {
            display: contents;
          }
          
          &:hover {
            background: ${(props) => props.theme.colors.inactive};
          }
          
          &:first-child{
            border-radius: 12px 12px 0 0;
          }

          &:last-child{
            border-radius: 0 0 12px 12px;
          }
        }
      }
    }

  .notes-card-container {
    cursor: default;
    display: flex;
    justify-content: space-between;
    gap: 16px;
    font-size: 13px;
    line-height: 18px;
  }

  .notes-card-footer {
    font-size: 13px;
    margin-top: 15px;
    width: 100%;
    color: ${(props) => props.theme.colors.inactive};

    .info {
      display: inline-flex;
      cursor: default;

      p {
        display: flex;
        align-items: center;

        label {
          margin-left: 5px;
        }
      }
      
      p.type {
        text-transform: capitalize;
      }

      p:not(:last-of-type)::after {
        content: '';
        width: 0;
        height: 18px;
        margin: 0 10px;
        border-left: 1px solid ${(props) => props.theme.colors.inactive};
      }
    }

    .actions {
      float: right;
      display: inline-flex;
    }

    .note-link {
      display: inline-block;
      cursor: pointer;

      i {
        width: 20px;
      }
    }

    .note-delete, .note-edit {
      display: inline-block;
      margin-left: 10px;
      cursor: pointer;
      
      i {
        width: 20px;

        svg path {
          stroke-width: 0.9px;
        }
      }
    }
  }
`;

export default { Wrapper };
